/* @ngInject */
function HomeWidgetController ($scope, $state, SegmentService) {
  $scope.goToModule = function (title) {
    if (title === 'requests') {
      SegmentService.track('workflow-widget-all')
      $state.go('workflow')
    } else if (title === 'posts') {
      SegmentService.track('announcement-widget-all-click')
      $state.go('posts')
    }
  }
}

export { HomeWidgetController }
